/** Парсинг `<multipleLimit>N</multipleLimit>` из метаданных TEXT (SwingText). */
export function parseMultipleLimitFromXml(raw: unknown): number | null {
  if (raw == null) return null
  const text =
    typeof raw === 'object' && raw !== null && '_text' in (raw as object)
      ? String((raw as { _text?: unknown })._text ?? '').trim()
      : String(raw).trim()
  if (!text) return null
  const n = parseInt(text, 10)
  if (!Number.isFinite(n) || n <= 0) return null
  return n
}

/**
 * Итоговый лимит: runtime (Element.setMultipleLimit / state) перекрывает XML.
 */
export function resolveElementMultipleLimit(options: {
  xmlLimit?: unknown
  runtimeLimit?: number | null
}): number | null {
  const runtime = options.runtimeLimit
  if (typeof runtime === 'number' && runtime > 0 && Number.isFinite(runtime)) {
    return runtime
  }
  return parseMultipleLimitFromXml(options.xmlLimit)
}
